import notificationReducer from "./notificationReducer";

const notificationReducers = {
    notification: notificationReducer
}

export default notificationReducers